module.exports = __webpack_public_path__ + "static/media/re.aab96447.jpg";